import { Logger } from "../../infrastructure/Logger";

export class Cache {

    constructor(name, timeSpan) {
        this.name = name;
        this.expirationTimeSpan = timeSpan;
    }

    add(key, payload) {
        var createDate = new Date();
        var expirationDate = new Date(createDate.getTime() + this.expirationTimeSpan * 60000);

        var item = {
            payload: payload,
            expirationDate: expirationDate
        };

        var cacheKey = this.name + '-' + key;
        sessionStorage.setItem(cacheKey, JSON.stringify(item));
        Logger.writeDebug('Added item with key ' + cacheKey + ' to cache', item.payload);
    }

    get(key) {
        var cacheKey = this.name + '-' + key;
        var json = sessionStorage.getItem(cacheKey);
        var item = JSON.parse(json);

        var now = new Date();
        if (item && item !== null && item.expirationDate && new Date(item.expirationDate).getTime() > now.getTime()) {
            Logger.writeDebug('Retrieved item with key ' + cacheKey + ' from cache', item.payload);
            return item.payload;
        }

        return null;
    }

    remove(key) {
        var cacheKey = this.name + '-' + key;
        sessionStorage.removeItem(cacheKey);
    }

    clear() {
        sessionStorage.clear();
    }

    getOrAdd(key, onLookupPromise) {
        console.log("debug: cache getOrAdd", key);
        var self = this;
        return new Promise(function (resolve, reject) {
            var payload = self.get(key);
            if (payload) {
                console.log("debug: cache hit", key);
                resolve(payload);
            }
            else {
                console.log("debug: cache miss");
                onLookupPromise(key)
                    .then(data => {
                        self.add(key, data);
                        resolve(data);
                    })
                    .catch(error => {
                        Logger.writeError("Could not get or retrieve item from cache", error);
                        reject(error);
                    });
            }
        });
    }

}
